// 金额格式 0.00 格式
let toDecimal = (x) => {
  var f = parseFloat(x)    
  if (isNaN(f)) {    
    return false
  }    
  f = Math.round(x*100)/100  
  var s = f.toString()   
  var rs = s.indexOf('.')   
  if (rs < 0) {    
    rs = s.length;    
    s += '.'    
  }    
  while (s.length <= rs + 2) {    
    s += '0'    
  }    
  return s 
}

export {
  toDecimal
}
